import { ICON_TYPES } from '../constants';

export const ArrowLightRightIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.418 24.542">
      <path
        data-name="Path 8"
        d="M.924,24.542h0V22.309L6.17,12.273.923,2.237V0L7.34,12.273Z"
        transform="translate(-0.923)"
      />
    </svg>
  );
};

ArrowLightRightIcon.iconType = ICON_TYPES.ARROW_LIGHT_RIGHT;
